import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Stack, IconButton, Typography } from '@mui/material';

import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import { Disclaimer } from '../../../components/Disclaimer';
import { WheelsTimeFiltersForm } from './wheels-time-filters-form';

export const HomeWheelsReservation = ({ onBackClick = () => {} }) => {
  const { t } = useTranslation();

  return (
    <Stack gap={3}>
      <Stack direction="row" alignItems="center" gap={1}>
        <IconButton onClick={onBackClick}>
          <KeyboardBackspaceIcon sx={{ color: 'rgba(239, 96, 163, 1)' }} />
        </IconButton>
        <Typography variant="h5" component="h2" color="primary" fontWeight={700}>
          {t('wheels_service.name')}
        </Typography>
      </Stack>
      <Typography variant="body2">{t('wheels_service.form_description')}</Typography>

      <WheelsTimeFiltersForm />

      <Disclaimer variant="important">
        <Disclaimer.Content>{t('wheels_service.form_alert_description')}</Disclaimer.Content>
      </Disclaimer>
    </Stack>
  );
};
